module.exports = __webpack_public_path__ + "static/media/global_expantion.d27351d2.jpg";